const main = {
  // 頁面標題和歡迎信息
  policyRegulation: "政策法規",
  blockchainKnowledge: "區塊鏈行業知識",
  blockchainCaseInvestigation: "區塊鏈案件偵查實錄",

  // 狀態提示
  loadingText: "拼命載入中",
  noDataText: "暫無數據",
};

// HelpHome 頁面內容
const helpHome = {
  helpCenterTitle: "幫助中心",
  expertService: "專家服務",
  productFunctionIntro: "產品功能介紹",
};

// judgmentBookDocuments 頁面內容
const judgmentBookDocuments = {
  originalText: "原文",
};

// National-involvment 頁面內容
const nationalInvolvment = {
  // 頁面標題
  judicialPrecedentTitle: "司法判例參考",

  // 搜索表單
  judgmentTitlePlaceholder: "請輸入文書標題",
  caseNumberPlaceholder: "請輸入案號",
  chargePlaceholder: "請輸入案由",
  caseTypePlaceholder: "請選擇案件",
  regionPlaceholder: "請選擇(省/市)",
  platformPlaceholder: "請選擇平台",
  procedurePlaceholder: "請選擇程序",

  // 日期選擇器
  dateRangeSeparator: "至",
  startDatePlaceholder: "開始日期",
  endDatePlaceholder: "結束日期",

  // 按鈕
  resetButton: "重置",
  searchButton: "查詢",

  // 狀態提示
  loadingText: "拼命載入中",
  noDataText: "暫無數據",

  // 案件信息標籤
  caseTypeLabel: "案件類型",
  caseNumberLabel: "案號",
  chargeLabel: "案由",
  regionLabel: "地區",
  platformLabel: "涉及平台",
  currencyLabel: "涉及幣種",

  // 默認選項
  allCases: "全部案件",
  allProvinces: "全部省份",
  allCities: "全部城市",
  allCurrencies: "全部幣種",
  allPlatforms: "全部平台",
  allProcedures: "全部程序",
};

// production-fun 頁面內容
const productionFun = {
  // 頁面標題和描述
  productFunctionIntro: "產品功能介紹",
  productDescription:
    "產品以虛擬幣地址為切入點，以鏈上交易溯源及匿名身份解析為核心，用於打擊涉虛擬貨幣新型犯罪的一站式查控平台，協助執法機關解決虛擬幣案件中的各類數據分析、案情拆解、及分析研判難題。",

  // 標籤頁
  productDemo: "產品演示",
  analysisResearch: "研判分析",
  evidenceManagement: "調證管理",
  dataDashboard: "數據看板",

  // 功能模組
  addressHashUserAnalysis: "地址、哈希、調證用戶分析",
  addressHashUserDesc:
    "一鍵查詢地址的基本交易數據、餘額與標籤。初步了解地址交易情況和標籤屬性",
  demoVideo: "演示視頻",

  characterAnalysis: "人物分析",
  characterAnalysisDesc:
    "針對已解析的司法調證文件，用人物分析ID搜索，可輕鬆查閱調證文件內容，完全掌握人物賬戶情況",

  caseAnalysis: "案件分析",
  caseAnalysisDesc:
    "建立案件畫布，圖形化展現鏈上轉賬關係，關注相關地址資金流向，深入查詢地址交易詳情",
  demoVideoCaseManagement: "演示視頻-案件管理",
  demoVideoCanvasAnalysis: "演示視頻-畫布分析",

  addressMonitoring: "地址監控",
  addressMonitoringDesc:
    "監控特定地址並實時通知鏈上轉賬信息，密切關注地址資金動向",

  aiModel: "AI模型",
  aiModelDesc:
    "查詢涉案地址手續費來源，快速得出地址的實控人線索，方便偵查人員進一步司法調證",

  labelManagement: "標籤管理",
  labelManagementDesc: "地址標籤自主管理，實時同步至畫布，分析效率顯著提升",

  evidenceSuggestion: "調證建議",
  evidenceSuggestionDesc:
    "一鍵生成、下載各大平台司法調證建議文書，步驟詳盡，讓司法調證“不迷路”",

  evidenceUser: "調證用戶",
  evidenceUserDesc: "調證返回文件全量整理，調證結果即刻查詢了解",

  evidenceUpload: "調證上傳",
  evidenceUploadDesc:
    "支持所有主流交易所調證文件上傳解析。可以使用解析生成的人物分析ID在案件畫布中直接分析，不僅能夠查看人物賬戶詳情，還能直觀展示人物轉賬關係",

  transactionData: "交易數據",
  transactionDataDesc: "案件關鍵地址交易數據一覽無餘，案件態勢一目了然",

  balanceData: "餘額數據",
  balanceDataDesc: "實時更新案件地址餘額，關注案件價值",
};

// prosecuteBook 頁面內容
const prosecuteBook = {
  // 頁面標題
  indictmentTitle: "起訴書",

  // 搜索表單
  titlePlaceholder: "請輸入文書標題",
  caseNumberPlaceholder: "請輸入案號",
  caseTypePlaceholder: "請選擇案件",
  regionPlaceholder: "請選擇(省/市)",
  platformPlaceholder: "請選擇平台",
  currencyPlaceholder: "請選擇幣種",

  // 日期選擇器
  dateRangeSeparator: "至",
  startDatePlaceholder: "開始日期",
  endDatePlaceholder: "結束日期",

  // 按鈕
  resetButton: "重置",
  searchButton: "查詢",

  // 狀態提示
  loadingText: "拼命載入中",
  noDataText: "暫無數據",

  // 案件信息標籤
  caseTypeLabel: "案件類型",
  caseNumberLabel: "案號",
  regionLabel: "地區",
  platformLabel: "涉及平台",
  currencyLabel: "涉及幣種",

  // 默認選項
  allCases: "全部案件",
  allProvinces: "全部省份",
  allCities: "全部城市",
  allCurrencies: "全部幣種",
  allPlatforms: "全部平台",
  allProcedures: "全部程序",
};

// ReferenceDocuments 頁面內容
const referenceDocuments = {
  // 狀態提示
  loadingText: "拼命載入中",

  // 文檔信息標籤
  courtLabel: "審理法院：",
  caseNumberLabel: "案號：",
  judgmentDateLabel: "裁判日期：",
  chargeLabel: "案由：",
  legalBasisLabel: "法律依據",
};

export default {
  ...main,
  ...helpHome,
  ...judgmentBookDocuments,
  ...nationalInvolvment,
  ...productionFun,
  ...prosecuteBook,
  ...referenceDocuments,
  // 子模組
};
